exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}@media (min-width:901px){html{font-size:130%}}@media (min-width:601px) and (max-width:900px){html{font-size:120%}}@media (max-width:600px){html{font-size:100%}}@media (max-width:350px){html{font-size:100%}}*,:after,:before{box-sizing:inherit}em{font-style:italic}.pager .counter{position:absolute;top:1rem;left:calc(50% - 2.25rem)}.pager .counter .slash{display:inline-block;width:1.5rem;text-align:center}.pager .counter .number{display:inline-block;width:3rem}.pager .counter .number.num{text-align:right}@media (max-width:600px){.pager .counter{top:5.85rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37c67859","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pager.vue
// module id = 33
// module chunks = 0